import { API_SECRET, API_URL } from '../config/appConfig';

const PRESENCE_PREFIX = 'fz:presence:';
const TTL_MS = 120000;

async function postPresence(body) {
  try {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_SECRET,
      },
      body: JSON.stringify(body),
    });
    const json = await res.json();
    return json?.data ?? json ?? null;
  } catch {
    return null;
  }
}

function key(farmId, collection, recordId) {
  return `${PRESENCE_PREFIX}${farmId || 'global'}:${collection || 'geral'}:${recordId || 'novo'}`;
}

export async function markRecordEditing({ farmId, collection, recordId, userName, title = '' }) {
  if (!recordId) return null;
  try {
    localStorage.setItem(key(farmId, collection, recordId), JSON.stringify({
      farmId: farmId || '',
      collection: collection || '',
      recordId: String(recordId),
      userName: userName || 'sistema',
      title: title || '',
      editingAt: new Date().toISOString(),
      expiresAt: Date.now() + TTL_MS,
    }));
  } catch {}
  return postPresence({ action: 'heartbeat_presence', farm_id: farmId || '', collection: collection || '', record_id: String(recordId), title: title || '', user_name: userName || 'sistema' });
}

export async function clearRecordEditing({ farmId, collection, recordId }) {
  if (!recordId) return null;
  try { localStorage.removeItem(key(farmId, collection, recordId)); } catch {}
  return postPresence({ action: 'clear_presence', farm_id: farmId || '', collection: collection || '', record_id: String(recordId) });
}

export function listCurrentEditingPresence() {
  try {
    const rows = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const storageKey = localStorage.key(i);
      if (!storageKey || !storageKey.startsWith(PRESENCE_PREFIX)) continue;
      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || 'null');
        if (parsed?.expiresAt && parsed.expiresAt >= Date.now()) rows.push(parsed);
      } catch {}
    }
    return rows.sort((a, b) => String(b.editingAt || '').localeCompare(String(a.editingAt || '')));
  } catch {
    return [];
  }
}

export async function listRemoteEditingPresence({ farmId = '', collection = '', recordId = '', limit = 25 } = {}) {
  const data = await postPresence({ action: 'get_presence', farm_id: farmId, collection, record_id: recordId || '', limit });
  return Array.isArray(data?.rows) ? data.rows : [];
}
